<template>
  <transition name="fade">
    <div class="vf-form-message vf-form-invalid">
      <p><strong>
        Sorry, your form cannot be submitted just yet. One or more required fields have not been completed.
      </strong></p>
      <!--<ul>
        <li 
          v-for="field in invalidFields" 
          :key="field.id">
          <a 
            :href="'#field-' + field.id"
            @click.prevent="$emit('goto', field.id)"
            class="no-underline">
            {{ field.label }}
          </a>
        </li>
      </ul>-->
    </div>    
  </transition>
</template>

<script>
export default { 
  name: 'ValidationError',
  props: {
    invalidFields: {
      type: Array,
      required: true
    }
  }
}

</script>
